export default function Company(state = [],action){

	if(action.type === "SET_MY_COMPANYS"){ state = action.data; }

	return state;

}